export default __webpack_public_path__ + "static/media/geodrop.f5551da6.svg";